import { render, staticRenderFns } from "./LiantongPhoneBinding.vue?vue&type=template&id=43e295b0&"
import script from "./LiantongPhoneBinding.vue?vue&type=script&lang=js&"
export * from "./LiantongPhoneBinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports